import React from 'react';

function CheckCircle(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.7141 9.00679C16.9215 8.73082 16.8658 8.33902 16.5898 8.13169C16.3139 7.92436 15.9221 7.98 15.7147 8.25598L10.4762 15.2288L8.12361 12.5234C7.8971 12.2629 7.50233 12.2354 7.24187 12.4619C6.9814 12.6884 6.95386 13.0832 7.18037 13.3436L9.63442 16.1657C10.1043 16.706 10.9527 16.6757 11.3828 16.1032L16.7141 9.00679Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default CheckCircle;
